import {Modal, ModalBody, ModalFooter} from "reactstrap";
import React from "react";
import './style.css'
import LinkTooltip from "../tooltip/link-tooltip";
import ButtonTooltip from "../tooltip/button-tooltip";

export const modalComponente = (
    modal,
    className,
    texto,
    toggle,
    funcao,
    tipo,
    innerRef
) => {

    const botoes = () => {
        if (tipo === 1) {
            return (
                <LinkTooltip
                    className="button-right"
                    content="Confirmar"
                    src="/images/Confirmar.svg"
                    href="/"
                    width={23}
                    height={23}
                    placement="bottom"
                    disabled={false}
                />
            );
        }

        if (tipo === 2) {
            return (
                <>
                    <ButtonTooltip
                        className="button-left"
                        content="Cancelar"
                        src="/images/Cancelar.svg"
                        type="button"
                        onClick={toggle}
                        width={23}
                        height={23}
                        placement="bottom"
                        innerRef={innerRef}
                    />
                    <ButtonTooltip
                        className="button-right"
                        content="Confirmar"
                        src="/images/Confirmar.svg"
                        type="button"
                        onClick={funcao}
                        width={23}
                        height={23}
                        placement="bottom"
                        innerRef={innerRef}
                    />
                </>
            );
        }

        if (tipo === 3) {
            return (
                <>
                    <ButtonTooltip
                        className="button-left teste"
                        content="Cancelar"
                        src="/images/Cancelar.svg"
                        type="button"
                        onClick={toggle}
                        width={23}
                        height={23}
                        placement="bottom"
                        innerRef={innerRef}
                    />

                    <ButtonTooltip
                        className="button-left button-right"
                        content="Salvar"
                        src="/images/Save.svg"
                        type="button"
                        onClick={funcao}
                        width={23}
                        height={23}
                        placement="bottom"
                        innerRef={innerRef}
                    />

                    <LinkTooltip
                        className="button-right"
                        content="Confirmar"
                        src="/images/Confirmar.svg"
                        href="/"
                        width={23}
                        height={23}
                        placement="bottom"
                        disabled={false}
                    />
                </>
            );
        }

        if (tipo === 4) {
            return (
                <>
                    <ButtonTooltip
                        className="button-right"
                        content="Confirmar"
                        src="/images/Confirmar.svg"
                        type="button"
                        onClick={funcao}
                        width={23}
                        height={23}
                        placement="bottom"
                        innerRef={innerRef}
                    />
                </>
            );
        }
    };

    return (
        <Modal isOpen={modal} toggle={toggle} zIndex={20} className={className}>
            <ModalBody>{texto}</ModalBody>
            <ModalFooter className="footer">{botoes()}</ModalFooter>
        </Modal>
    );
};
